export const AUTO_REPLY_DATE_FORMAT = 'YYYY-MM-DD';

/** Минимальная дата в прошлом: «год − 1 день» от сегодня (364 дня назад). */
export const AUTO_REPLY_MIN_PAST_OFFSET_DAYS = 364;

export enum AutoReplyFormFieldNameEnum {
    RuleType = 'ruleType',
    BrandCatalogCompany = 'brandCatalogCompany',
    StoreCatalog = 'storeCatalog',
}
